export const Name = 'invite-card-cta-order';
